export default __webpack_public_path__ + "static/media/carousel-02-indumentaria-masculina.2bbbaeb2.png";